import { useEffect, useRef, useState } from "react";
import "./Bookings.css";
import {
  validateAndFormatPostCodeFromWeb,
  validatePostCode,
} from "../../utils/postCodeValidation";
import { useMultistepForm } from "../../hooks/MultiStepForm/useMultiStepForm";
import SenderForm from "./components/SenderForm/SenderForm";
import ReceiverForm from "./components/ReceiverForm/ReceiverForm";
import ParcelForm from "./components/ParcelForm/ParcelForm";
import { BsArrowRight } from "react-icons/bs";
import { BsArrowLeft } from "react-icons/bs";
import PaymentMethod from "./components/PaymentMethod/PaymentMethod";
import ProgressBar from "./components/ProgressBar/ProgressBar";
import PickupForm from "./components/PickupForm/PickupForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ShippingInformation from "./components/ShippingInformation/ShippingInformation";
import axios from "axios";
import dayjs from "dayjs";
import Finalize from "./components/Finalize/Finalize";
import WhereToGo from "./components/WhereToGo/WhereToGo";
import Swal from "sweetalert2";
import { useHref, useNavigate, useLocation } from "react-router-dom";
import Payment from "./components/Payment/Payment";
import GetLocalStorageUserId from "../sharedComponents/GetLocalStorageuserId";
import sideImg from "../../../src/assets/images/booking/sideImage.png";
import jwtDecode from "jwt-decode";
import UserTokenHandler from "../sharedComponents/UserTokenHandler";
import { redirectToIdentityLogin } from "../../utils/identityLogin";
import { resolveCurrencySymbol } from "../../utils/formatCurrency";
import StripePayment from "./components/Payment/StripePayment";
import ManualBankPayment from "./components/Payment/ManualBankPayment";
import { clearPaymentSlipUploadSessionFlags } from "../payments/paymentSlipDebug";
import { markSelfParcelBookingCreated } from "../../utils/parcelBookingNotifications";
import { dispatchNotificationsRefresh } from "../../types/notification.types";
import { refreshCustomerDashboardData } from "../../utils/customerDashboardRefresh";
import { isAdminUser, isCustomerUser } from "../../utils/jwtRole";
import {
  isMangoShipmentReady,
  loadMangoTransitCost,
  readMangoPricingDraft,
  summarizeTransitCostResults,
} from "../../utils/mangoBookingFlow";
import { isMangoFeatureEnabled } from "../../utils/featureFlags";
import { MANUAL_PAYMENT_TYPE_ID } from "../../utils/manualPayment";
import { createManualBankPaymentInvoice } from "../../api/manualPaymentApi";
const apiAddress = process.env.REACT_APP_API_URL;

const DEFAULT_CARGO_TYPE_ID = 1;

function getDefaultShipmentFields() {
  const today = dayjs();
  return {
    cargoType: String(DEFAULT_CARGO_TYPE_ID),
    selectedShipmentArrivalDate: today.format("YYYY-MM-DD"),
    shipmentArrivalDate: {
      day: today.format("dddd"),
      date: today.date(),
      month: today.format("MMMM"),
      year: String(today.year()),
    },
  };
}

const Bookings = ({ tittle, flow = "standard" }) => {
  const isMangoFlow = flow === "mango";
  const mangoFeatureEnabled = isMangoFeatureEnabled();
  const backendUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const move = useNavigate();
  // const [decodedToken, setDecodedToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [currencyTypes, setCurrencyTypes] = useState([]);
  const [exchangeRates, setExchangeRates] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("GBP");
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  // Require login for bookings; if token not present and no user details, redirect to Identity with returnUrl back here.
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const hasTokenInUrl = !!queryParams.get("token");
    const storedUser = localStorage.getItem("sundorbonBookingUserDetails");
    const storedToken =
      localStorage.getItem("sundorbonToken") || localStorage.getItem("token");

    if (!hasTokenInUrl && (!storedUser || !storedToken)) {
      const returnUrl = `${window.location.origin}${location.pathname}${location.search}`;
      redirectToIdentityLogin(returnUrl);
    }
  }, [location.pathname, location.search]);

  // Mango shipment page: only after landing-page modal + cost calculation
  useEffect(() => {
    if (!isMangoFlow) return;
    if (!mangoFeatureEnabled) {
      move("/bookings", { replace: true });
      return;
    }
    const draft = readMangoPricingDraft();
    if (!draft || !isMangoShipmentReady()) {
      toast.error("Please complete mango booking details on the home page first.");
      move("/", { replace: true });
    }
  }, [isMangoFlow, mangoFeatureEnabled, move]);

  // Clear pricing draft when website is closed
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("sundorbonPricingDraft");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // useEffect(() => {
  //   // Extract the token from the URL
  //   const queryParams = new URLSearchParams(location.search);
  //   const Sundarbantoken = queryParams.get("token");

  //   if (Sundarbantoken) {
  //     // Store token in localStorage
  //     localStorage.setItem("Sundarbantoken", Sundarbantoken);

  //     // Decode token to get user details
  //     const decoded = jwtDecode(Sundarbantoken); // Decoding JWT token
  //     setDecodedToken(decoded);

  //     // Optionally, store decoded details in localStorage for easier access
  //     localStorage.setItem("decodedToken", JSON.stringify(decoded));
  //   } else {
  //     // Handle missing token (e.g., redirect to login)
  //     move("/login");
  //   }
  // }, [location.search, move]);

  // Use decodedToken for rendering user-specific content
  console.log(userId);

  // get local storage data.
  const localdata = localStorage.getItem("sundorbonBookingUserDetails");
  const localStorageObj = JSON.parse(localdata);
  console.log(localStorageObj);

  // Clear pricing draft when website is closed
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("sundorbonPricingDraft");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // const move = useNavigate();
  const INITIAL_DATA = {
    route: "",
    senderName: "",
    senderEmail: "",
    senderMobileNumber: "",
    senderCountry: "",
    senderLandmark: "",
    pickupLandmark: "",
    senderCity: "",
    senderPostCode: "",
    senderDoorNo: "",
    senderStreetName: "",
    senderRemarks: "",
    pickupCity: "",
    pickupCountry: "",
    senderAddress: "",
    receiverName: "",
    receiverEmail: "",
    receiverMobileNumber: "",
    receiverCountry: "",
    receiverLandmark: "",
    receiverCity: "",
    receiverPostCode: "",
    receiverDoorNo: "",
    receiverStreetName: "",
    receiverRemarks: "",
    receiverAddress: "",
    numberOfItems: "",
    parcelContent: "",
    shipmentTime: "",
    producDetails: [
      {
        productGroup: "",
        productGroupName: "",
        productType: "",
        productTypeName: "",
        itemDescription: "",
        productValue: "",
        productQty: 0,
      },
    ],
    productGroup: "",
    productType: "",
    itemDescription: "",
    productValue: "",

    packaging: "",
    fragileItems: "",
    preset: "A4 Envelope",
    additionalInfo: "",
    productWeight: "1",
    productLength: "12",
    productWidth: "9",
    productHeight: "1",
    paymentTypeId: "2",
    paymentInvoiceNo: "",
    shipmentType: "",
    IsScheduled: "",
    scheduledDate: {},
    pickupLocation: "",
    pickupWeight: "",
    pickupInstructions: "",
    pickupTimeFrom: "",
    pickupTimeTo: "",
    cargoType: String(DEFAULT_CARGO_TYPE_ID),
    shipmentArrivalDate: getDefaultShipmentFields().shipmentArrivalDate,
    selectedShipmentArrivalDate:
      getDefaultShipmentFields().selectedShipmentArrivalDate,
    scheduledDateToggleValue: "",
    pickupTimeFromToggleValue: "",
    pickupTimeToToggleValue: "",
    pickupAsSenderCheckToggle: false,
    BookedById: "",
  };

  const [data, setData] = useState(INITIAL_DATA);
  console.dir(data);
  function updateFields(fields) {
    setData((prev) => {
      return { ...prev, ...fields };
    });
  }

  // Prefill booking form from pricing draft (saved by Quotation modal "Book Now")
  useEffect(() => {
    const PRICING_DRAFT_KEY = "sundorbonPricingDraft";
    const raw = localStorage.getItem(PRICING_DRAFT_KEY);
    if (!raw) return;

    try {
      const draft = JSON.parse(raw);
      if (!draft?.routeId) return;
      if (!isMangoFlow && draft?.pricingType === "mango") return;
      if (isMangoFlow && draft?.pricingType !== "mango") return;

      const parcel = draft?.parcel || {};

      // Basic prefill (route, post codes, parcel fields)
      updateFields({
        route: String(draft.routeId),
        senderPostCode: (draft.fromPostCode || "").toUpperCase(),
        receiverPostCode: (
          draft.receiverPostCode ||
          draft.toPostCode ||
          ""
        ).toUpperCase(),
        ...(isMangoFlow && draft.mangoSetupComplete
          ? {
              receiverName: draft.receiverName || "",
              receiverEmail: draft.receiverEmail || "",
              receiverMobileNumber: draft.receiverMobileNumber || "",
              receiverCountry: draft.receiverCountry
                ? String(draft.receiverCountry)
                : "",
              receiverCity: draft.receiverCity ? String(draft.receiverCity) : "",
              receiverLandmark: draft.receiverLandmark || "",
              receiverDoorNo: draft.receiverDoorNo || "",
              receiverStreetName: draft.receiverStreetName || "",
              receiverRemarks: draft.receiverRemarks || "",
              receiverAddress: draft.receiverAddress || "",
              additionalInfo: draft.additionalInfo || "",
            }
          : {}),
        // Prefer manual parcel values from draft; allow user to change in form
        preset: "",
        productWeight:
          parcel.weight !== undefined &&
          parcel.weight !== null &&
          parcel.weight !== ""
            ? String(parcel.weight)
            : "",
        productLength:
          parcel.length !== undefined &&
          parcel.length !== null &&
          parcel.length !== ""
            ? String(parcel.length)
            : "",
        productWidth:
          parcel.width !== undefined &&
          parcel.width !== null &&
          parcel.width !== ""
            ? String(parcel.width)
            : "",
        productHeight:
          parcel.height !== undefined &&
          parcel.height !== null &&
          parcel.height !== ""
            ? String(parcel.height)
            : "",
      });

      // Mango pricing: preselect Item Group (Category) = Fruits (id 19) and Item Type = Mango (id 18)
      if (isMangoFlow && draft?.pricingType === "mango") {
        setData((prev) => {
          const current = Array.isArray(prev.producDetails)
            ? prev.producDetails
            : [];
          const first = current[0] || {
            productGroup: "",
            productGroupName: "",
            productType: "",
            productTypeName: "",
            itemDescription: "",
            productValue: "",
            productQty: 0,
          };

          const mangoQty = parseInt(draft?.mango?.qty, 10);
          const updated = [
            {
              ...first,
              productGroup: 19,
              productGroupName: "Fruits",
              productType: 18,
              productTypeName: "Mango",
              productQty: mangoQty >= 3 ? mangoQty : 3,
            },
            ...current.slice(1),
          ];

          return {
            ...prev,
            producDetails: updated,
            productGroup: 19,
            productType: 18,
          };
        });
      }
    } catch (err) {
      console.log("Invalid pricing draft:", err?.message || err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMangoFlow]);

  const [transitCost, setTransitCost] = useState([]);
  const [mangoTransitCostLoaded, setMangoTransitCostLoaded] = useState(false);

  console.log(transitCost);
  const [arrivalDate, setArrivalDate] = useState({});
  // fetching booking form data.
  const [arrivalDateInfo, setArivalDateInfo] = useState([]);

  const [fetchedFormData, setfetchedFormData] = useState({});
  const [routesLoading, setRoutesLoading] = useState(true);
  const [fruitsWeights, setFruitsWeights] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [presets, setPresets] = useState([]);
  const formKeys = fetchedFormData;

  useEffect(() => {
    /// fetching arrival date info.
    // axios.get("./dummyData.json").then((res) => setArivalDateInfo(res.data));

    // api get request url and state seter functions and ulrs.
    const getFormData = [
      {
        url: "PaymentTypeMethod",
        key: "paymentMethod",
      },
      {
        url: "Country",
        key: "country",
      },
      {
        url: "city",
        key: "city",
      },
      {
        url: "ProductType",
        key: "ProductType",
      },
      {
        url: "ParcelContent",
        key: "ParcelContent",
      },
      {
        url: "Prohibiteditem",
        key: "Prohibiteditem",
      },
      {
        url: "Cargotype",
        key: "Cargotype",
      },
      {
        url: "Route",
        key: "Route",
      },
      {
        url: "itemType",
        key: "itemType",
      },
    ];

    // Fetched form data and set to state.

    // getFormData?.forEach(({ url, key }) => {
    //   axios
    //     .get(apiAddress + url)
    //     .then((res) => {
    //       formKeys[key] = res.data;
    //       return setfetchedFormData({ ...formKeys });
    //     })
    //     .catch((err) => {
    //       console.log(err.message);
    //     });
    // });

    // Fetch all data in parallel for better performance
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    // Prioritize Route API call - fetch it first
    const routeData = getFormData.find((item) => item.key === "Route");
    const otherData = getFormData.filter((item) => item.key !== "Route");

    // Fetch Route first for faster dropdown loading
    if (routeData) {
      axios
        .get(apiAddress + routeData.url, { headers })
        .then((res) => {
          formKeys[routeData.key] = res.data;
          setfetchedFormData({ ...formKeys });
          setRoutesLoading(false);
        })
        .catch((err) => {
          console.log(`Error fetching ${routeData.key}:`, err.message);
          setRoutesLoading(false);
        });
    }

    // Fetch remaining data in parallel
    Promise.all(
      otherData.map(({ url, key }) =>
        axios
          .get(apiAddress + url, { headers })
          .then((res) => ({ key, data: res.data }))
          .catch((err) => {
            console.log(`Error fetching ${key}:`, err.message);
            return { key, data: [] }; // Return empty array on error to prevent blocking
          }),
      ),
    ).then((results) => {
      // Update state with all fetched data
      const updatedFormData = { ...formKeys };
      results.forEach(({ key, data }) => {
        updatedFormData[key] = data;
      });
      setfetchedFormData(updatedFormData);
    });

    // Fetch dimensions and use them as presets
    axios
      .get(`${apiAddress}Dimension`, { headers })
      .then((res) => {
        const dimensionsData = res.data || [];
        setDimensions(dimensionsData);

        // Convert dimensions to presets format
        // Filter only active dimensions if needed, or use all
        const presetsData = dimensionsData
          .filter((dim) => dim.isActive !== false) // Only show active dimensions
          .map((dim) => ({
            id: dim.id,
            name:
              dim.dimensionName?.replace(/_/g, " ") || dim.dimensionName || "", // Replace underscores with spaces
            dimensionName: dim.dimensionName,
            length: dim.length,
            width: dim.width,
            height: dim.height,
            weight: dim.weight || null, // Weight may not be in Dimension API
            routeId: dim.routeId,
            routeName: dim.routeName,
            isActive: dim.isActive,
          }));

        setPresets(presetsData);
      })
      .catch((err) => {
        console.log("Error fetching dimensions:", err.message);
        setDimensions([]);
        setPresets([]);
      });

    // Fetch item categories to find Fruits category
    axios
      .get(`${apiAddress}ItemCategory`, { headers })
      .then((res) => {
        const itemCategories = res.data || [];
        // Find Fruits category ID
        const fruitsCategory = itemCategories.find(
          (cat) => cat.name === "Fruits" || cat.id === 19,
        );
        if (fruitsCategory) {
          // Fetch weights filtered by Fruits category
          axios
            .get(`${apiAddress}Weight`, { headers })
            .then((weightRes) => {
              const allWeights = weightRes.data || [];
              // Filter weights where itemCategoryId matches Fruits
              const fruitsWeightsList = allWeights.filter(
                (weight) => weight.itemCategoryId === fruitsCategory.id,
              );
              setFruitsWeights(fruitsWeightsList);
            })
            .catch((err) => {
              console.log("Error fetching weights:", err.message);
            });
        }
      })
      .catch((err) => {
        console.log("Error fetching item categories:", err.message);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Pre-fill sender info for mango pricing (separate effect that runs after fetchedFormData is available)
  useEffect(() => {
    const PRICING_DRAFT_KEY = "sundorbonPricingDraft";
    const raw = localStorage.getItem(PRICING_DRAFT_KEY);
    if (!raw) return;

    try {
      const draft = JSON.parse(raw);
      if (
        isMangoFlow &&
        draft?.pricingType === "mango" &&
        draft?.senderInfo &&
        fetchedFormData.country &&
        fetchedFormData.city
      ) {
        const { country, city } = fetchedFormData;
        // Find UK country (id 22) - check both id and name (case-insensitive)
        const ukCountry = country?.find(
          (c) => c.id === 22 || (c.name && c.name.toLowerCase() === "uk"),
        );
        // Find London city - case-insensitive match
        const londonCity = city?.find(
          (c) => c.name && c.name.toLowerCase() === "london",
        );

        updateFields({
          senderName: draft.senderInfo.senderName || "",
          senderEmail: draft.senderInfo.senderEmail || "",
          senderMobileNumber: draft.senderInfo.senderMobileNumber || "",
          senderCountry: ukCountry ? String(ukCountry.id) : "",
          senderCity: londonCity ? String(londonCity.id) : "",
          senderAddress: draft.senderInfo.senderAddress || "",
          senderPostCode: draft.senderInfo.senderPostCode || "",
        });
      }
    } catch (err) {
      console.log("Error prefilling sender info:", err?.message || err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedFormData, isMangoFlow]);

  // Mango: prefill parcel dimensions/weight from selected box (weightId) once data loads
  useEffect(() => {
    if (!isMangoFlow) return;
    const draft = readMangoPricingDraft();
    if (!draft?.mango?.weightId || fruitsWeights.length === 0) return;

    const weightId = parseInt(draft.mango.weightId, 10);
    const weight = fruitsWeights.find((w) => w.id === weightId);
    const dimId = weight?.dimensionId ?? draft.mango?.dimensionId;
    const dim = dimensions.find((d) => d.id === parseInt(dimId, 10));
    const parcel = draft.parcel || {};
    const parsedQty = parseInt(draft.mango?.qty, 10);
    const mangoQty = Math.min(
      5,
      Math.max(1, Number.isFinite(parsedQty) ? parsedQty : 1),
    );

    const length = dim?.length ?? parcel.length ?? "";
    const width = dim?.width ?? parcel.width ?? "";
    const height = dim?.height ?? parcel.height ?? "";
    const weightVal =
      weight?.minimumWeight ?? weight?.maximumWeight ?? parcel.weight ?? "";

    setData((prev) => {
      const current = Array.isArray(prev.producDetails) ? prev.producDetails : [];
      const first = current[0] || {};
      const updatedFirst = {
        ...first,
        productGroup: 19,
        productGroupName: "Fruits",
        productType: 18,
        productTypeName: "Mango",
        itemDescription: "mango",
        productValue: "0",
        productQty: mangoQty,
        itemPackaging: "No",
        itemLength: length !== "" && length != null ? String(length) : first.itemLength,
        itemWidth: width !== "" && width != null ? String(width) : first.itemWidth,
        itemHeight: height !== "" && height != null ? String(height) : first.itemHeight,
        itemWeight:
          weightVal !== "" && weightVal != null ? String(weightVal) : first.itemWeight,
      };

      return {
        ...prev,
        packaging: "No",
        productLength:
          length !== "" && length != null ? String(length) : prev.productLength,
        productWidth:
          width !== "" && width != null ? String(width) : prev.productWidth,
        productHeight:
          height !== "" && height != null ? String(height) : prev.productHeight,
        productWeight:
          weightVal !== "" && weightVal != null
            ? String(weightVal)
            : prev.productWeight,
        producDetails: [updatedFirst, ...current.slice(1)],
        productGroup: 19,
        productType: 18,
      };
    });
  }, [fruitsWeights, dimensions, isMangoFlow]);

  // api response data from shipment arrival date page.

  const [pickUpCost, setPickUpCost] = useState(0);
  const [routeCost, setRouteCost] = useState(0);
  const [itemTypeCost, setItemTypeCost] = useState(0);
  const [itemCategoryCost, setItemCategoryCost] = useState(0);
  const [weightCost, setWeightCost] = useState(0);
  const [dimensionCost, setDimensionCost] = useState(0);
  const [extraPackagingCost, setExtraPackagingCost] = useState(0);
  const [cargoCost, setCargoCost] = useState(0);
  const [shippingServicePercentage, setShippingServicePercentage] = useState(0);
  const [shippingServiceAmount, setShippingServiceAmount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatAmountPercentage, setVatAmountPercentage] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [discountedOfferId, setDiscountedOfferId] = useState(null);
  const [shippingServiceId, setShippingServiceId] = useState(null);
  const [dimensionId, setDimensionId] = useState(null);
  const [weightId, setWeightId] = useState(null);

  // parcel barcode number.
  const [bookingBarcodeNumber, setBookingBarcodeNumber] = useState(null);
  const [manualInvoiceNumber, setManualInvoiceNumber] = useState("");
  const [manualOrderAmount, setManualOrderAmount] = useState("");

  // Load transit cost calculated on the landing page before Create shipment
  useEffect(() => {
    if (!isMangoFlow || mangoTransitCostLoaded) return;
    const stored = loadMangoTransitCost();
    if (!stored?.length) return;

    const summary = summarizeTransitCostResults(stored);
    setTransitCost(summary.transitionCostResults);
    setPickUpCost(summary.totalPickUpCost);
    setRouteCost(summary.totalRouteCost);
    setItemCategoryCost(summary.totalItemCategoryCost);
    setItemTypeCost(summary.totalItemTypeCost);
    setWeightCost(summary.totalWeightCost);
    setDimensionCost(summary.totalDimensionCost);
    setExtraPackagingCost(summary.totalExtraPackagingCost);
    setCargoCost(summary.totalCargoCost);
    setTotalCost(summary.totalCost);
    setVatAmountPercentage(summary.vatPercentageAmount);
    setMangoTransitCostLoaded(true);
  }, [isMangoFlow, mangoTransitCostLoaded]);

  useEffect(() => {
    axios
      .get(`${backendUrl}Currency/GetAllActiveCurrency`)
      .then((res) => setCurrencyTypes(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load currency");
      });
  }, [backendUrl]);

  useEffect(() => {
    axios
      .get(`${backendUrl}Currency/GetAllCurrencyExchangeRate`)
      .then((res) => setExchangeRates(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load currency rate");
      });
  }, [backendUrl]);

  const getRate = (targetCurrency) => {
    if (targetCurrency === "GBP") return 1;
    const rateObj = exchangeRates.find(
      (r) => r.baseCurrency === "GBP" && r.targetCurrency === targetCurrency,
    );
    return rateObj ? rateObj.rate : 1;
  };

  const getCurrencySymbol = (currency) => {
    const match = currencyTypes.find((c) => c.currencyType === currency);
    return resolveCurrencySymbol(match?.symbol, currency || "GBP");
  };

  const convert = (amount) => {
    const rate = getRate(selectedCurrency);
    return (amount * rate).toFixed(2);
  };

  // Create the utilities object
  const currencyUtils = {
    getRate,
    getCurrencySymbol,
    convert,
    selectedCurrency,
    setSelectedCurrency,
    currencyTypes,
    exchangeRates,
  };

  const baseSteps = isMangoFlow
    ? [
        <Finalize
          {...data}
          bookingBarcodeNumber={bookingBarcodeNumber}
          fetchedFormData={fetchedFormData}
          transitCost={transitCost}
          updateFields={updateFields}
          currencyUtils={currencyUtils}
        />,
        <PaymentMethod
          fetchedFormData={fetchedFormData}
          {...data}
          paymentTypeId={data.paymentTypeId}
          updateFields={updateFields}
        />,
      ]
    : [
        <WhereToGo
          routesLoading={routesLoading}
          {...data}
          updateFields={updateFields}
          fetchedFormData={fetchedFormData}
        />,
        <SenderForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
        />,
        <ReceiverForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
        />,
        <ParcelForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
          fruitsWeights={fruitsWeights}
          dimensions={dimensions}
          presets={presets}
        />,
        <Finalize
          {...data}
          bookingBarcodeNumber={bookingBarcodeNumber}
          fetchedFormData={fetchedFormData}
          transitCost={transitCost}
          updateFields={updateFields}
          currencyUtils={currencyUtils}
        />,
        <PaymentMethod
          fetchedFormData={fetchedFormData}
          {...data}
          paymentTypeId={data.paymentTypeId}
          updateFields={updateFields}
        />,
      ];

  // Define payment method steps
  const paymentSteps = {
    2: [<StripePayment />], // Online Payment (Stripe)
    [MANUAL_PAYMENT_TYPE_ID]: [
      <ManualBankPayment
        invoiceNumber={manualInvoiceNumber}
        orderAmount={manualOrderAmount}
        currencySymbol={resolveCurrencySymbol(selectedCurrency)}
      />,
    ],
  };

  // Combine all steps
  const allSteps = [...baseSteps, ...(paymentSteps[data.paymentTypeId] || [])];

  const { currentStepIndex, step, isFirstStep, isLastStep, back, next, goTo } =
    useMultistepForm(allSteps);

  const receiverStepIndex = 2;
  const parcelStepIndex = 3;
  const finalizeStepIndex = isMangoFlow ? 0 : 4;
  const paymentMethodStepIndex = isMangoFlow ? 1 : 5;

  // If we come from /payment-failed "Try again", jump user straight back to Stripe step.
  const resumePaymentRequestedRef = useRef(false);
  useEffect(() => {
      if (location.state?.resumePayment) {
      resumePaymentRequestedRef.current = true;
      updateFields({ paymentTypeId: "2" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    if (!resumePaymentRequestedRef.current) return;
    if (String(data.paymentTypeId) !== "2") return;
    // StripePayment is the last step once paymentTypeId=2
    goTo(allSteps.length - 1);
    resumePaymentRequestedRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.paymentTypeId, allSteps.length]);

  const validateFields = () => {
    const isManualFilled =
      data.productWeight &&
      data.productLength &&
      data.productWidth &&
      data.productHeight;
    if (!data.preset && !isManualFilled) {
      toast.error("Please select a preset or fill in all the fields.");
      return false;
    }
    // if (isManualFilled) {
    //     updateFields({ preset: '' }); // Reset preset if manual fields are filled
    // }
    const { scheduledDate, IsScheduled, pickupTimeTo, pickupTimeFrom } = data;

    // if (
    //   Object.keys(scheduledDate).length <= 0 &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select scheduled date.");
    //   return false;
    // } else if (transitCost.length === 0 && currentStepIndex === 5) {
    //   toast.error("Please Select Shipment Arrival Date And Shipment Process.");
    //   return false;
    // } else if (
    //   pickupTimeFrom === "" &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select From time.");
    //   return false;
    // } else if (
    //   pickupTimeTo === "" &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select scheduled To time.");
    //   return false;
    // } else if (IsScheduled === "" && currentStepIndex === 4) {
    //   toast.error("You have to select at least one option.");
    //   return false;
    // }

    return true;
  };

  function formatDate(dateObj) {
    // Helper function to get the month number from the month name
    function getMonthNumber(monthName) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthName);
    }

    // Extract and format the year, month, and day
    let year = parseInt(dateObj?.year?.trim());
    let month = getMonthNumber(dateObj?.month); // Zero-based month index for Date object
    let day = parseInt(dateObj?.day);

    // Set a default time (12:11:39.027) or you can set it as per your requirement
    let hours = 12;
    let minutes = 11;
    let seconds = 39;
    let milliseconds = 27;

    // Create the Date object
    let date = new Date(
      Date.UTC(year, month, day, hours, minutes, seconds, milliseconds),
    );

    // Convert to ISO 8601 format and return
    return date?.toISOString();
  }

  function combineDateAndTime(dateStr, timeStr) {
    // Extract year, month, and day from the date string
    const [year, month, day] = dateStr.split("-").map(Number);

    // Extract hours and minutes from the time string
    const [hours, minutes] = timeStr.split(":").map(Number);

    // Create the Date object with the provided date and time
    const date = new Date(Date.UTC(year, month - 1, day, hours, minutes));

    // Convert to ISO 8601 format and return
    return date?.toISOString();
  }

  function formatDateToString(dateObj) {
    // Helper function to get the month number from the month name
    function getMonthNumber(monthName) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthName) + 1;
    }

    // Extract and format the year, month, and day
    let year = dateObj?.year?.trim();
    let month = getMonthNumber(dateObj.month)?.toString()?.padStart(2, "0");
    let day = dateObj?.day?.padStart(2, "0");

    // Combine into the desired format
    return `${year}-${month}-${day}`;
  }

  // get booking page url.
  const url = useHref();
  console.log(url);

  const fetchTotalTransitionCost = async () => {
    const shipmentDefaults = getDefaultShipmentFields();
    updateFields(shipmentDefaults);

    const bookingData = { ...data, ...shipmentDefaults };
    const {
      route,
      productLength,
      productWeight,
      productHeight,
      productWidth,
      packaging,
      IsScheduled,
      producDetails,
    } = bookingData;

    const routingTypeId = parseInt(route);
    const parcelLength = parseFloat(productLength);
    const parcelWidth = parseFloat(productWidth);
    const parcelHeight = parseFloat(productHeight);
    const parcelWeight = parseFloat(productWeight);
    const cargoTypeId = DEFAULT_CARGO_TYPE_ID;
    const isExtraPackaging = packaging === "Yes";
    const isPickUp = IsScheduled === "yes";
    const selectedShipmentArrivalDate =
      bookingData.selectedShipmentArrivalDate;

    try {
      const transitionCostRequests = producDetails
        .filter((item) => {
          const itemTypeId = parseInt(item.productType);
          const itemCategoryId = parseInt(item.productGroup);
          return (
            !isNaN(itemTypeId) &&
            !isNaN(itemCategoryId) &&
            itemTypeId > 0 &&
            itemCategoryId > 0
          );
        })
        .map((item, index) => {
          const itemTypeId = parseInt(item.productType);
          const itemCategoryId = parseInt(item.productGroup);
          const productQty = parseInt(item.productQty) || 0;

          const itemParcelLength = parseFloat(
            item.itemLength !== undefined && item.itemLength !== ""
              ? item.itemLength
              : index === 0
                ? parcelLength
                : 0,
          );
          const itemParcelWidth = parseFloat(
            item.itemWidth !== undefined && item.itemWidth !== ""
              ? item.itemWidth
              : index === 0
                ? parcelWidth
                : 0,
          );
          const itemParcelHeight = parseFloat(
            item.itemHeight !== undefined && item.itemHeight !== ""
              ? item.itemHeight
              : index === 0
                ? parcelHeight
                : 0,
          );
          const itemParcelWeight = parseFloat(
            item.itemWeight !== undefined && item.itemWeight !== ""
              ? item.itemWeight
              : index === 0
                ? parcelWeight
                : 0,
          );

          const itemIsExtraPackaging =
            (item.itemPackaging !== undefined
              ? item.itemPackaging
              : index === 0
                ? packaging
                : "No") === "Yes";

          return {
            routingTypeId,
            parcelLength: itemParcelLength,
            parcelWidth: itemParcelWidth,
            parcelHeight: itemParcelHeight,
            parcelWeight: itemParcelWeight,
            cargoTypeId,
            isExtraPackaging: itemIsExtraPackaging,
            isPickUp,
            itemTypeId,
            itemCategoryId,
            shipmentArrivalDate: selectedShipmentArrivalDate,
            productQty,
          };
        });

      if (transitionCostRequests.length === 0) {
        toast.error("Please complete parcel product details.");
        return false;
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}TransitionCost/GetTotalTransitionCost`;
      const response = await axios.post(apiUrl, transitionCostRequests, {
        headers: { "Content-Type": "application/json" },
      });

      const transitionCostResults = Array.isArray(response.data)
        ? response.data
        : [response.data];

      const rowAmount = (result) =>
        parseFloat(
          result?.totalCost ??
            result?.totalCostWithoutVAT ??
            result?.totalCostWithVAT ??
            0,
        ) || 0;

      const totalCost = transitionCostResults.reduce(
        (sum, result) => sum + rowAmount(result),
        0,
      );
      const totalPickUpCost = transitionCostResults.reduce(
        (sum, result) => sum + result.pickUpCost,
        0,
      );
      const totalRouteCost = transitionCostResults.reduce(
        (sum, result) => sum + result.routeCost,
        0,
      );
      const totalItemCategoryCost = transitionCostResults.reduce(
        (sum, result) => sum + result.itemCategoryCost,
        0,
      );
      const totalItemTypeCost = transitionCostResults.reduce(
        (sum, result) => sum + result.itemTypeCost,
        0,
      );
      const totalWeightCost = transitionCostResults.reduce(
        (sum, result) => sum + result.weightCost,
        0,
      );
      const totalDimensionCost = transitionCostResults.reduce(
        (sum, result) => sum + result.dimensionCost,
        0,
      );
      const totalExtraPackagingCost = transitionCostResults.reduce(
        (sum, result) => sum + result.extraPackagingCost,
        0,
      );
      const totalCargoCost = transitionCostResults.reduce(
        (sum, result) => sum + result.cargoCost,
        0,
      );
      const vatPercentageAmount = transitionCostResults.reduce(
        (sum, result) => sum + result.vatPercentageAmount,
        0,
      );

      setTransitCost(transitionCostResults);
      setPickUpCost(totalPickUpCost);
      setRouteCost(totalRouteCost);
      setItemCategoryCost(totalItemCategoryCost);
      setItemTypeCost(totalItemTypeCost);
      setWeightCost(totalWeightCost);
      setDimensionCost(totalDimensionCost);
      setExtraPackagingCost(totalExtraPackagingCost);
      setCargoCost(totalCargoCost);
      setTotalCost(totalCost);
      setVatAmountPercentage(vatPercentageAmount);

      return true;
    } catch (error) {
      console.log(error);
      toast.error("Failed to calculate shipping cost.");
      return false;
    }
  };

  const onSubmit = async (e) => {
    console.log("Current Step Index:", currentStepIndex);
    e.preventDefault();

    // if ([3, 4, 5].includes(currentStepIndex) && !validateFields()) return;
    // if (!isLastStep) return next();

    // Validate receiver form postcode if country is UK (standard flow only)
    if (!isMangoFlow && currentStepIndex === receiverStepIndex) {
      const { receiverPostCode, receiverCountry } = data;
      const { country } = fetchedFormData;

      // Check if country is UK
      const isUK =
        receiverCountry === "22" ||
        receiverCountry === 22 ||
        country
          ?.find((c) => String(c.id) === String(receiverCountry))
          ?.name?.toLowerCase() === "uk";

      if (isUK && receiverPostCode) {
        try {
          const validation = await validateAndFormatPostCodeFromWeb(
            receiverPostCode.trim(),
            receiverCountry,
            country || [],
          );
          if (!validation.isValid) {
            toast.error(
              `Invalid post code: ${validation.error}. Please enter a valid UK post code.`,
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return; // Don't proceed to next step
          }
          // Update formatted postcode if different
          if (validation.formatted !== receiverPostCode.trim()) {
            updateFields({ receiverPostCode: validation.formatted });
          }
        } catch (error) {
          console.error("Post code validation error:", error);
          // Fallback to format validation
          const formatValidation = validatePostCode(
            receiverPostCode.trim(),
            receiverCountry,
            country || [],
          );
          if (!formatValidation.isValid) {
            toast.error(
              `Invalid post code: ${formatValidation.error}. Please enter a valid UK post code.`,
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return; // Don't proceed to next step
          }
        }
      } else if (isUK && !receiverPostCode) {
        toast.error("Please enter a post code for UK addresses.", {
          position: "top-right",
          autoClose: 5000,
        });
        return; // Don't proceed to next step
      }
    }

    // Parcel step: fetch cost → Create shipment (Finalize) — standard flow only
    if (!isMangoFlow && currentStepIndex === parcelStepIndex) {
      if (!validateFields()) {
        return;
      }
      const costOk = await fetchTotalTransitionCost();
      if (!costOk) return;
      return next();
    }

    // If we're on the payment method selection step
    if (currentStepIndex === paymentMethodStepIndex) {
      const isManual = String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID;
      const ok = await handleFinalSubmit({
        // Open /paymentslip as the invoice page for manual bank transfer
        suppressSlipOpen: !isManual,
        suppressRedirect: true,
        createManualInvoice: isManual,
      });
      if (ok) next();
      return;
    }

    // Manual bank transfer: invoice page already opened — finish after user confirms
    if (
      isLastStep &&
      String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
    ) {
      Swal.fire({
        title: "Booking created",
        html: manualInvoiceNumber
          ? `Your invoice has been opened. Please transfer using invoice <strong>${manualInvoiceNumber}</strong> as the payment reference. An admin will verify your payment.`
          : "Your invoice has been opened. Please complete the bank transfer using the invoice number as payment reference. An admin will verify your payment.",
        icon: "success",
        confirmButtonText: "Go to Dashboard",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        if (url === "/agency-bookings") {
          move("/agent-dashboard");
        } else if (url === "/admin-bookings") {
          move("/admin-dashboard");
        } else {
          move("/user-dashboard");
        }
      });
      return;
    }

    // For other cases, proceed to next step
    if (!isLastStep) return next();

    // Handle final submission for other payment methods
    await handleFinalSubmit();
  };

  const handleFinalSubmit = async (options = {}) => {
    const {
      suppressSlipOpen = false,
      suppressRedirect = false,
      createManualInvoice = false,
    } = options;
    const {
      senderName,
      senderEmail,
      senderAddress,
      senderLandmark,
      senderMobileNumber,
      senderPostCode,
      senderDoorNo,
      senderStreetName,
      senderRemarks,
      receiverName,
      receiverEmail,
      receiverAddress,
      receiverLandmark,
      receiverMobileNumber,
      receiverPostCode,
      receiverDoorNo,
      receiverStreetName,
      receiverRemarks,
      itemDescription,
      additionalInfo = "N/A", // Default if empty
      pickupTimeFrom,
      pickupTimeTo,
      pickupInstructions,
      producDetails,
    } = data;

    // Get currency info
    const selectedCurrencyType = currencyTypes.find(
      (currency) => currency.currencyType === selectedCurrency,
    );
    const currencyTypeId = selectedCurrencyType?.id;

    if (!currencyTypeId) {
      toast.error("Invalid currency selected");
      return;
    }

    // Get conversion rate
    const conversionRate = getRate(selectedCurrency);

    // Conversion function
    const convertCost = (amount) => (amount * conversionRate).toFixed(2);

    // Prepare products array with all items
    const products = producDetails.map((item, index) => {
      // Get per-item costs from transitCost
      const itemTransitCost = transitCost[index] || transitCost[0] || {};
      const itemWeightId = itemTransitCost.weightCostId || 0;
      const itemDimensionId = itemTransitCost.dimensionId || 0;
      const itemWeightCost = parseFloat(
        convertCost(itemTransitCost.weightCost || 0),
      );
      const itemDimensionCost = parseFloat(
        convertCost(itemTransitCost.dimensionCost || 0),
      );
      const itemItemCategoryCost = parseFloat(
        convertCost(itemTransitCost.itemCategoryCost || 0),
      );
      const itemItemTypeCost = parseFloat(
        convertCost(itemTransitCost.itemTypeCost || 0),
      );
      const itemExtraPackagingCost = parseFloat(
        convertCost(itemTransitCost.extraPackagingCost || 0),
      );
      const itemCargoCost = parseFloat(
        convertCost(itemTransitCost.cargoCost || 0),
      );

      return {
        itemCategoryId: parseInt(item.productGroup),
        itemCategoryCost: itemItemCategoryCost,
        itemTypeId: parseInt(item.productType),
        itemTypeCost: itemItemTypeCost,
        dimensionId: itemDimensionId,
        dimensionCost: itemDimensionCost,
        weightId: itemWeightId,
        weightCost: itemWeightCost,
        uniqItemDescription: item.itemDescription || itemDescription || "",
        itemValue: parseFloat(convertCost(item.productValue)),
        isExtraPackaging:
          (item.itemPackaging !== undefined
            ? item.itemPackaging
            : index === 0
              ? data.packaging
              : "No") === "Yes",
        extraPackagingCost: itemExtraPackagingCost,
        parcelAdditionalInfo: additionalInfo,
        cargoTypeId: parseInt(data.cargoType, 10) || DEFAULT_CARGO_TYPE_ID,
        cargoCost: itemCargoCost,
        productQty: parseInt(item.productQty) || 0,
      };
    });

    // Prefer live transitCost rows (same numbers shown on Finalize).
    // Some API responses populate totalCostWithoutVAT / totalCostWithVAT but leave totalCost empty.
    const transitCostTotal = Array.isArray(transitCost)
      ? transitCost.reduce((sum, tc) => {
          const rowAmount =
            parseFloat(
              tc?.totalCost ??
                tc?.totalCostWithoutVAT ??
                tc?.totalCostWithVAT ??
                0,
            ) || 0;
          return sum + rowAmount;
        }, 0)
      : 0;

    const effectiveTotalCost =
      transitCostTotal > 0 ? transitCostTotal : parseFloat(totalCost) || 0;

    if (!(effectiveTotalCost > 0)) {
      toast.error(
        "Booking amount is £0. Please go back and recalculate shipping cost before paying.",
      );
      return false;
    }

    // Calculate aggregated totals for the booking
    const totalSubTotal = parseFloat(convertCost(effectiveTotalCost));
    const totalVATAmount = parseFloat(convertCost(vatAmountPercentage || 0));
    const totalOrderPayableAmount = totalSubTotal; // OrderPayableAmount equals SubTotal (VAT not added)

    // Prepare single booking object with products array
    const bookingData = {
      companyId: 0,
      routingTypeId: parseInt(data.route),
      routeCost: parseFloat(convertCost(routeCost || 0)),
      senderName: senderName,
      senderEmail: senderEmail,
      senderMobileNo: senderMobileNumber,
      senderCountryId: parseInt(data.senderCountry),
      senderCityId: parseInt(data.senderCity),
      senderLandMark: senderLandmark || "",
      senderPostCode: senderPostCode || "",
      senderAdditionalAddressInfo: senderAddress || "",
      senderDoorNo: senderDoorNo || "",
      senderStreetName: senderStreetName || "",
      senderRemarks: senderRemarks || "",
      receiverName: receiverName,
      receiverEmail: receiverEmail,
      receiverMobileNo: receiverMobileNumber,
      receiverCountryId: parseInt(data.receiverCountry),
      receiverCityId: parseInt(data.receiverCity),
      receiverLandMark: receiverLandmark || "",
      receiverPostCode: receiverPostCode || "",
      receiverAdditionalAddressInfo: receiverAddress || "",
      receiverDoorNo: receiverDoorNo || "",
      receiverStreetName: receiverStreetName || "",
      receiverRemarks: receiverRemarks || "",
      isPickup: data.IsScheduled === "yes",
      pickupDate:
        data.IsScheduled === "yes"
          ? formatDate(data.scheduledDate)
          : "2024-07-24",
      fromTime:
        data.IsScheduled === "yes"
          ? combineDateAndTime(
              formatDateToString(data.scheduledDate),
              pickupTimeFrom,
            )
          : "2024-07-24",
      toTime:
        data.IsScheduled === "yes"
          ? combineDateAndTime(
              formatDateToString(data.scheduledDate),
              pickupTimeTo,
            )
          : "2024-07-24",
      pickUpCountryId:
        data.IsScheduled === "yes" ? parseInt(data.pickupCountry) : 0,
      pickUpCityId: data.IsScheduled === "yes" ? parseInt(data.pickupCity) : 0,
      pickUpLandMark: data.senderLandmark || "",
      pickUpAdditionalAddressInfo: data.senderAddress || "",
      parcelPickUpInstractions: pickupInstructions || "",
      pickupCost: parseFloat(convertCost(pickUpCost || 0)),
      subTotal: totalSubTotal,
      vaT_TaxParcentage: 0,
      vaT_TaxAmount: totalVATAmount,
      orderPayableAmount: totalOrderPayableAmount,
      shippingServiceId: 0,
      shippingServicePercentage: 0,
      shippingServiceAmount: parseFloat(
        convertCost(shippingServiceAmount || 0),
      ),
      discountPercentage: 0,
      discountedOfferId: 0,
      discountAmount: parseFloat(convertCost(discountAmount || 0)),
      isAgent: tittle === "Agency Booking" && localStorageObj?.Type === "Agent",
      agentId:
        localStorageObj?.Id && tittle === "Agency Booking"
          ? String(localStorageObj?.Id)
          : "",
      branchId: 1,
      paymentTypeMethodId: parseInt(data?.paymentTypeId),
      paymentInvoiceNo: data?.paymentInvoiceNo || "",
      bookedById: userId || "",
      currencyTypeId: currencyTypeId,
      creatorId: GetLocalStorageUserId() || "",
      modifierId: GetLocalStorageUserId() || "",
      isActive: true,
      products: products,
    };

    console.log("Booking Data:", bookingData);

    try {
      const response = await axios.post(`${apiAddress}TransitionCost`, [
        bookingData,
      ]);

      if (response.status === 200) {
        // Backend returns array of results - use first one for parent booking info
        // All items should share the same parent booking
        const bookingResults = Array.isArray(response.data) ? response.data : [];
        markSelfParcelBookingCreated(bookingResults);
        if (isAdminUser()) {
          dispatchNotificationsRefresh();
        } else if (isCustomerUser()) {
          refreshCustomerDashboardData().catch(() => {});
        }

        const returnedData =
          bookingResults.length > 0 ? bookingResults[0] : {};

        const paymentSlipData = {
          ...data,
          pricingType: isMangoFlow ? "mango" : "regular",
          isMangoBooking: isMangoFlow,
          transitCost: transitCost.map((tc) => ({
            ...tc,
            totalCost: convertCost(tc.totalCost),
            discountAmount: convertCost(tc.discountAmount),
            totalCostWithoutVAT: convertCost(tc.totalCostWithoutVAT),
            vatPercentageAmount: convertCost(tc.vatPercentageAmount),
          })),
          bookingBarcodeNumber: returnedData?.number || returnedData?.barcode,
          parcelId: returnedData?.parcelId || returnedData?.id,
          recordSerialNo: returnedData?.recordSerialNo,
          currencyType: selectedCurrency,
          currencyTypeId,
          producDetails: data.producDetails.map((item) => ({
            ...item,
            productValue: item.productValue,
            productGroupName: item.productGroupName,
            productTypeName: item.productTypeName,
          })),
        };

        if (createManualInvoice) {
          try {
            const invoiceResult = await createManualBankPaymentInvoice({
              parcelId: paymentSlipData.parcelId,
              recordSerialNo: paymentSlipData.recordSerialNo,
              orderAmount: totalOrderPayableAmount,
              currencyTypeId,
              bookedById: userId || GetLocalStorageUserId() || "",
              description: `Manual bank transfer for booking ${
                paymentSlipData.recordSerialNo ||
                paymentSlipData.bookingBarcodeNumber ||
                ""
              }`,
            });

            paymentSlipData.paymentInvoiceNo = invoiceResult.invoiceNumber;
            paymentSlipData.paymentTypeId = MANUAL_PAYMENT_TYPE_ID;
            setManualInvoiceNumber(invoiceResult.invoiceNumber);
            setManualOrderAmount(String(totalOrderPayableAmount));
            updateFields({
              paymentInvoiceNo: invoiceResult.invoiceNumber,
              paymentTypeId: MANUAL_PAYMENT_TYPE_ID,
            });
          } catch (invoiceErr) {
            console.error("Manual invoice creation failed:", invoiceErr);
            toast.error(
              "Booking created, but invoice number could not be generated. Please contact support.",
            );
          }
        }

        // Store in localStorage
        localStorage.setItem(
          "paymentSlipData",
          JSON.stringify(paymentSlipData),
        );
        clearPaymentSlipUploadSessionFlags(
          paymentSlipData.parcelId,
          paymentSlipData.recordSerialNo,
        );
        // Mark booking API flow complete (Stripe step can start now)
        sessionStorage.setItem("bookingApisCompleted", "1");

        // GTM: booking_complete data layer push (only once per booking)
        try {
          const bookingId =
            returnedData?.recordSerialNo ||
            returnedData?.parcelId ||
            returnedData?.id ||
            paymentSlipData.bookingBarcodeNumber;

          if (
            bookingId &&
            window.__bookingCompletePushed !== String(bookingId)
          ) {
            const totalAmount = totalSubTotal;

            const productQtyTotal = Array.isArray(producDetails)
              ? producDetails.reduce(
                  (sum, item) => sum + (parseInt(item.productQty) || 0),
                  0,
                )
              : 0;

            // Sum all item weights (fallback to global productWeight if needed)
            const totalWeightKg = Array.isArray(producDetails)
              ? producDetails.reduce(
                  (sum, item) =>
                    sum +
                    (parseFloat(item.itemWeight || item.productWeight || 0) ||
                      0),
                  0,
                )
              : parseFloat(data.productWeight || 0) || 0;

            // Route as human-readable route name, e.g. "Dhaka → London"
            const selectedRoute =
              fetchedFormData?.Route && Array.isArray(fetchedFormData.Route)
                ? fetchedFormData.Route.find(
                    (r) => String(r.id) === String(data.route),
                  )
                : null;
            const routeLabel =
              selectedRoute?.routeName ||
              (selectedRoute?.startingArea && selectedRoute?.endingArea
                ? `${selectedRoute.startingArea} \u2192 ${selectedRoute.endingArea}`
                : "");

            // Parcel type from first product's category name
            const parcelType =
              Array.isArray(producDetails) && producDetails.length > 0
                ? producDetails[0].productGroupName || ""
                : "";

            // Shipping service name (e.g. "Express", "Standard"), from transitCost
            const serviceType =
              Array.isArray(transitCost) && transitCost.length > 0
                ? transitCost[0]?.shippingServiceName || ""
                : "";

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "booking_complete",
              booking: {
                booking_id: String(bookingId),
                booking_status: "confirmed",
                booking_date: new Date()
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
                route: routeLabel,
                service_type: serviceType,
                parcel_type: parcelType,
                weight_kg: totalWeightKg,
                quantity: productQtyTotal,
                total_amount: totalAmount,
                currency: selectedCurrency || "GBP",
                payment_method:
                  String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
                    ? "bank_transfer"
                    : "stripe",
                payment_status: "unpaid",
                invoice_number: paymentSlipData.paymentInvoiceNo || "",
              },
              customer: {
                customer_id: localStorageObj?.Id
                  ? String(localStorageObj.Id)
                  : "",
                name: senderName || "",
                phone: senderMobileNumber || "",
                email: senderEmail || "",
                city: data.senderCity || "",
                country: data.senderCountry || "",
              },
            });

            // Mark as pushed to avoid duplicate firing on reload
            window.__bookingCompletePushed = String(bookingId);
          }
        } catch (e) {
          console.error("GTM booking_complete dataLayer push failed:", e);
        }

        // Clear pricing draft from localStorage after successful booking
        localStorage.removeItem("sundorbonPricingDraft");

        setBookingBarcodeNumber(response.data[0]?.number);

        if (!suppressSlipOpen) {
          window.open("/paymentslip", "_blank");
        }

        if (suppressRedirect) {
          toast.success("Booking created. Please complete payment.");
          return true;
        }

        Swal.fire({
          title: "Booking created successfully",
          text: "Payment slip has been opened in a new tab.",
          icon: "success",
          confirmButtonText: "Go to Dashboard",
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (
            result.isConfirmed ||
            result.dismiss === Swal.DismissReason.backdrop
          ) {
            // Redirect based on the booking page URL
            if (url === "/agency-bookings") {
              move("/agent-dashboard");
            } else if (url === "/admin-bookings") {
              move("/admin-dashboard");
            } else if (url === "/bookings") {
              move("/user-dashboard");
            } else {
              // Default fallback
              move("/user-dashboard");
            }
          }
        });
        return true;
      }
    } catch (error) {
      console.error("Booking error:", error.response?.data || error);
      toast.error(
        `Failed to create booking: ${error.response?.data?.title || error.message}`,
      );
      return false;
    }
  };

  const stepNames = isMangoFlow
    ? [
        "Receiver",
        "Parcel",
        "Create shipment",
        "Payment Method",
        ...(data.paymentTypeId === "2" ? ["Online Payment"] : []),
        ...(String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
          ? ["Bank Transfer"]
          : []),
      ]
    : [
        "Route",
        "Sender",
        "Receiver",
        "Parcel",
        "Review",
        "Payment Method",
        ...(data.paymentTypeId === "2" ? ["Online Payment"] : []),
        ...(String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
          ? ["Bank Transfer"]
          : []),
      ];

  console.log("data", data);
  console.log(vatAmountPercentage);
  return (
    <div className="bookingContainer lg:pb-0 pb-5 flex flex-col gap-0 justify-end items-center w-full overflow-x-hidden">
      <ToastContainer />

      {/* Form + Side image wrapper */}
      <div className="w-full flex flex-col lg:flex-row lg:items-stretch">
        {/* Left: booking form */}
        <div className="w-full lg:w-1/2 pt-11 flex flex-col">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1 className="xl:text-5xl  lg:text-4xl text-3xl font-normal pageTittle px-4">
              {tittle}
            </h1>
            <hr className="underline-custom" />
          </div>

          <form onSubmit={onSubmit} className=" relative">
            {/* <div className="absolute top-[90px] left-0 w-full">
            <ProgressBar
              data={data}
              currentStepIndex={currentStepIndex}
              steps={steps}
              stepNames={stepNames}
            />
          </div> */}
            {/* step page container part. */}

            <div className="grid grid-cols-1 lg:flex lg:flex-row lg:items-start lg:justify-center gap-3 xl:gap-5 px-2 sm:px-4">
              <div className="w-full h-full flex flex-col items-center justify-center">
                {/* Centered Content */}
                <div className="flex justify-center items-center w-full max-w-4xl">
                  {step}
                </div>

                {/* Bottom Part */}
                {/* <div
                  className={`flex px-4 pb-4 ${
                    isFirstStep ? "flex-row-reverse" : "flex-row"
                  } items-center mt-6 gap-4`}
                >
                  {!isFirstStep && (
                    <button
                      type="button"
                      onClick={back}
                      className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                    >
                      Back
                    </button>
                  )}

                  <button
                    type="submit"
                    className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                  >
                    {isLastStep ? "Finish" : "Next"}
                  </button>
                </div> */}
                <div
                  className={`flex px-4 pb-4 ${
                    isFirstStep ? "flex-row-reverse" : "flex-row"
                  } items-center mt-6 gap-4`}
                >
                  {!isFirstStep &&
                    !(
                      data.paymentTypeId === "2" &&
                      currentStepIndex === allSteps.length - 1
                    ) && (
                      <button
                        type="button"
                        onClick={back}
                        className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                      >
                        Back
                      </button>
                    )}
                  {/* Stripe step uses its own Pay button */}
                  {!(
                    data.paymentTypeId === "2" &&
                    currentStepIndex === allSteps.length - 1
                  ) && (
                    <button
                      type="submit"
                      className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                    >
                      {isLastStep
                        ? String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
                          ? "I have noted the details"
                          : "Finish"
                        : isMangoFlow &&
                            currentStepIndex === finalizeStepIndex
                          ? "Continue to payment"
                          : "Next"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {/* Right: side image (desktop only) */}
        <img
          src={sideImg}
          alt=""
          className="hidden lg:block lg:w-1/2 object-cover"
        />
      </div>
    </div>
  );
};

export default Bookings;
